import { Message } from "@redux/modules/value/messages/messages.utils";

export const $MessagesModuleName = "messages";

export type TMessagesState = Array<Message>